import React from "react";

const TabbarDataCardLayout = ({ children }) => {
  return <div className="flex flex-col desktop:flex-row gap-[10px] w-full desktop:p-2 mb-5 desktop:mb-0">{children}</div>;
};

export default TabbarDataCardLayout;
